class KnowledgeHub {
  constructor(selector) {
    this.container = document.querySelector(selector);
    if (!this.container) return;
    this.loader = this.container.querySelector(".knowledge-hub-loader");
    this.gridWrapper = this.container.querySelector(".knowledge-hub-grid-wrapper");
    this.grid = this.container.querySelector(".knowledge-hub-grid");
    this.search = this.container.querySelector("#knowledge-search");
    this.search = this.container.querySelector("#knowledge-search");
    this.searchClear = this.container.querySelector(".search-clear");
    this.categoryButtons = [...this.container.querySelectorAll(".category-filter")];
    this.loadMoreButton = this.container.querySelector(".knowledge-load-more");
    this.results = this.container.querySelector(".knowledge-hub__results");
    this.tagList = this.container.querySelector(".blog-tags__list");
    this.articleCatLinks = [...this.container.querySelectorAll(".article__category-link")];
    this.resetButton = this.container.querySelector(".knowledge-hub-filters-reset");

    this.filters = {
      search: "",
      category: null,
      tag: null,
      page: 1,
    };

    this.perPage = 6;
    this.articles = [];
    this.filteredArticles = [];
    this.init();
  }

  init() {
    this.collectArticles();
    this.sortArticles();
    this.buildTagFilters();
    this.getFiltersFromURL();
    this.bindEvents();
    this.syncUIFromFilters();
    // this.applyFilters();

    requestAnimationFrame(() => {
      this.applyFilters();

      requestAnimationFrame(() => {
        this.loader?.classList.add("hidden");
      });
    });
  }

  syncUIFromFilters() {
    this.updateCategoryUI();
    this.updateTagUI();

    if (this.search) {
      this.search.value = this.filters.search;
      this.updateSearchClearButton();
    }
  }

  capitalize(text) {
    return text

      .split(" ")

      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))

      .join(" ");
  }

  slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  showLoader() {
    this.loader.hidden = false;
  }

  hideLoader() {
    this.loader.hidden = true;
  }

  scrollToGrid(offset = 100) {
    // if (window.innerWidth >= 1024) return;

    const top = this.gridWrapper.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  }

  collectArticles() {
    this.articles = [...this.grid.querySelectorAll(".knowledge-article")].map((element) => {
      const title = (element.dataset.title || "").trim();

      const excerpt = (element.dataset.excerpt || "").trim();

      const blog = (element.dataset.blog || "").trim();

      const blogTitle = (element.dataset.blogTitle || "").trim();

      const tags = (element.dataset.tags || "")
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag.length > 0)
        .map((tag) => ({
          label: tag,
          slug: this.slugify(tag),
        }));

      const date = Number(element.dataset.date) || 0;

      const url = element.dataset.url || "";

      const searchIndex = [title, excerpt, blogTitle, ...tags.map((tag) => tag.label)].join(" ").toLowerCase();

      return {
        element,

        title,

        excerpt,

        blog,

        blogTitle,

        tags,

        date,

        url,

        searchIndex,
      };
    });
  }

  sortArticles() {
    this.articles.sort((a, b) => b.date - a.date);
  }

  buildTagFilters() {
    if (!this.tagList) return;

    // Clear existing tags
    this.tagList.innerHTML = "";

    // Create a Map for unique tags
    const uniqueTags = new Map();

    this.articles.forEach((article) => {
      article.tags.forEach((tag) => {
        if (!uniqueTags.has(tag.slug)) {
          uniqueTags.set(tag.slug, tag);
        }
      });
    });

    // Sort alphabetically
    const sortedTags = [...uniqueTags.values()].sort((a, b) => a.label.localeCompare(b.label));

    // Add remaining tags
    sortedTags.forEach((tag) => {
      this.tagList.insertAdjacentHTML(
        "beforeend",
        `
            <li>

                <button
                    class="tag-filter"
                    data-tag="${tag.label}"
                    data-tag-slug="${tag.slug}"
                    aria-pressed="false"
                    type="button">
                    ${this.capitalize(tag.label)}
                </button>

            </li>
            `,
      );
    });
  }

  getFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    this.filters.category = params.get("category");
    this.filters.tag = params.get("tag");

    this.filters.search = params.get("search") || "";
  }

  updateURL() {
    const params = new URLSearchParams();

    if (this.filters.category) params.set("category", this.filters.category);

    if (this.filters.tag) params.set("tag", this.filters.tag);

    if (this.filters.search) params.set("search", this.filters.search);

    const url = params.toString() ? `${window.location.pathname}?${params}` : window.location.pathname;

    history.replaceState({}, "", url);
  }

  setCategory(category) {
    this.filters.category = category;

    this.filters.page = 1;

    this.updateCategoryUI();

    this.applyFilters();
  }

  updateCategoryUI() {
    this.categoryButtons.forEach((button) => {
      const active = button.dataset.blog === this.filters.category;

      button.classList.toggle("active", active);

      button.setAttribute("aria-pressed", active);
    });
  }

  updateTagUI() {
    this.tagList.querySelectorAll(".tag-filter").forEach((button) => {
      const active = button.dataset.tagSlug === this.filters.tag;

      button.classList.toggle("active", active);

      button.setAttribute("aria-pressed", active);
    });
  }

  updateSearchClearButton() {
    if (!this.searchClear || !this.search) return;

    this.searchClear.style.display = this.search.value ? "block" : "none";
  }

  matchesSearch(article) {
    if (!this.filters.search) return true;

    return article.searchIndex.includes(this.filters.search);
  }

  resetFilters() {
    this.filters.search = "";

    if (this.search) {
      this.search.value = "";
      this.updateSearchClearButton();
    }

    this.filters.category = null;
    this.filters.tag = null;
    this.filters.page = 1;

    this.updateCategoryUI();
    this.updateTagUI();

    this.applyFilters(true);
  }

  bindEvents() {
    this.loadMoreButton?.addEventListener("click", () => {
      this.filters.page++;

      this.render(false);
    });

    if (this.articleCatLinks) {
      this.articleCatLinks.forEach((catLink) => {
        catLink.addEventListener("click", (event) => {
          event.preventDefault();
          this.setCategory(catLink.dataset.blog);
        });
      });
    }

    if (this.search) {
      this.search.addEventListener("input", (e) => {
        this.filters.search = e.target.value.trim().toLowerCase();

        this.filters.page = 1;

        this.updateSearchClearButton();

        this.applyFilters(false);
      });

      this.search.addEventListener("blur", () => {
        if (this.filters.search) {
          this.scrollToGrid();
        }
      });

      this.search.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();

          if (this.filters.search) {
            this.scrollToGrid();
          }

          this.search.blur();
        }
      });
    }

    if (this.searchClear) {
      this.searchClear.addEventListener("click", () => {
        this.search.value = "";
        this.search.focus();

        this.filters.search = "";
        this.filters.page = 1;

        this.updateSearchClearButton();

        this.applyFilters(false);
      });
    }

    if (this.categoryButtons) {
      this.categoryButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const category = button.dataset.blog;

          // Toggle category
          if (this.filters.category === category) {
            this.filters.category = null;
          } else {
            this.filters.category = category;
          }

          this.filters.page = 1;

          this.updateCategoryUI();
          this.applyFilters(true);
        });
      });
    }

    this.tagList.addEventListener("click", (event) => {
      const button = event.target.closest(".tag-filter");

      if (!button) return;

      const tag = button.dataset.tagSlug;

      if (this.filters.tag === tag) {
        this.filters.tag = null;
      } else {
        this.filters.tag = tag;
      }

      this.filters.page = 1;

      this.updateTagUI();

      this.applyFilters(true);
    });

    if (this.resetButton) {
      this.resetButton.addEventListener("click", () => this.resetFilters());
    }
  }

  applyFilters(scrollToTop = false) {
    const hasFilters = this.filters.search || this.filters.category || this.filters.tag;

    this.resetButton.hidden = !hasFilters;

    this.filteredArticles = this.articles.filter((article) => {
      return (
        this.matchesSearch(article) &&
        (!this.filters.category || article.blog === this.filters.category) &&
        (!this.filters.tag || article.tags.some((tag) => tag.slug === this.filters.tag))
      );
    });

    this.filters.page = 1;

    this.updateURL();

    this.render(scrollToTop);
  }

  render(scrollToTop = false) {
    this.grid.innerHTML = "";
    const fragment = document.createDocumentFragment();
    const limit = this.filters.page * this.perPage;
    this.filteredArticles.slice(0, limit).forEach((item) => {
      item.element.style.display = "block";
      fragment.appendChild(item.element);
    });
    this.grid.appendChild(fragment);
    this.updateLoadMore();
    this.updateResults();

    // Scroll to top of results on mobile
    if (scrollToTop) {
      this.scrollToGrid();
    }
  }

  updateLoadMore() {
    if (this.filteredArticles.length <= this.filters.page * this.perPage) {
      this.loadMoreButton.hidden = true;
    } else {
      this.loadMoreButton.hidden = false;
    }
  }

  updateResults() {
    const filteredArticlesCount = this.filteredArticles.length;
    this.results.textContent = `${filteredArticlesCount} articles found`;

    if (filteredArticlesCount == 0) {
      this.results.textContent = "No articles found";
      this.results.style.display = "flex";
    } else {
      this.results.style.display = "none";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new KnowledgeHub(".knowledge-hub");
});
